import { gql } from '@apollo/client';

export const GET_SUBJECT_MATTER = gql`
    query lp_read($options: read_options, $region: Region!, $type: DeLp_Type!) {
        lp_read(options: $options, region: $region, type: $type) {
            message
            ok
            status
            total_count
            error {
                message
                path
            }
            data {
                subject_matter {
                    subject_matter_id
                    subject_matter_heading
                    description
                    case_id
                }
            }
        }
    }
`;
